import { IFiltersValues, TFilterValueRecord } from '@diana/core';
import { FilterType } from '../stores/useFilters';
import { Barge } from '../stores/useFilterOptions';

type Button = {
  name: string;
  displayName: string;
  value: string;
};

export const transformAccordionToFilters = (
  expandedAccordions: string[],
  activeButtons: Record<string, Button>,
  timeRangeValue: any = {},
  dataGroupedByBarge?: { barges: Barge[] } | null,
): IFiltersValues => {
  const barges: TFilterValueRecord[] = [];
  const mfmDevices: TFilterValueRecord[] = [];

  expandedAccordions.forEach((accordion) => {
    if (activeButtons[accordion]) {
      const activeButton = activeButtons[accordion];
      // Find barge by name to get systemId
      const barge = dataGroupedByBarge?.barges.find((b) => b.name === accordion);
      const bargeValue = barge?.systemId || accordion; // Fallback to name if systemId not found
      barges.push({ value: bargeValue, displayName: accordion });
      mfmDevices.push({ value: activeButton.value, displayName: activeButton.name });
    }
  });

  return {
    [FilterType.BARGES]: barges,
    [FilterType.MFM_DEVICES]: mfmDevices,
    [FilterType.TIME_RANGE]: timeRangeValue,
  };
}; 